import {type VariantProps} from 'class-variance-authority';
import * as React from 'react';

import {cn} from '@/utils/ui';

import {paperVariants} from './paper-variants';

type PaperProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof paperVariants>;

const Paper = React.forwardRef<HTMLDivElement, PaperProps>(
  ({className, variant, ...props}, ref) => (
    <div
      ref={ref}
      className={cn(paperVariants({variant}), className)}
      {...props}
    />
  )
);
Paper.displayName = 'Paper';

export {Paper};
export type {PaperProps};
